import { computed } from 'vue'
import type { QSectionProps, StyleProps } from './use-section-props'

/**
 * 合并样式属性的 composable
 */
export function useSectionMergedStyles(props: QSectionProps) {
  const propsData = computed(() => {
    return props.uiMeta?.props || {}
  })

  const mergedStyles = computed<StyleProps>(() => {
    return {
      ...propsData.value.styles,
      // 直接属性优先级更高
      w: props.w || propsData.value.styles?.w,
      h: props.h || propsData.value.styles?.h,
      wh: props.wh || propsData.value.styles?.wh,
      f: props.f || propsData.value.styles?.f,
      fs: props.fs || propsData.value.styles?.fs,
      fc: props.fc || propsData.value.styles?.fc,
      fw: props.fw || propsData.value.styles?.fw,
      b: props.b || propsData.value.styles?.b,
      bw: props.bw || propsData.value.styles?.bw,
      bs: props.bs || propsData.value.styles?.bs,
      bc: props.bc || propsData.value.styles?.bc,
      bgC: props.bgC || propsData.value.styles?.bgC,
      bgI: props.bgI || propsData.value.styles?.bgI,
      bgS: props.bgS || propsData.value.styles?.bgS || 'cover',
      bgP: props.bgP || propsData.value.styles?.bgP,
      bgR: props.bgR || propsData.value.styles?.bgR,
      m: props.m || propsData.value.styles?.m,
      mt: props.mt || propsData.value.styles?.mt,
      ml: props.ml || propsData.value.styles?.ml,
      mr: props.mr || propsData.value.styles?.mr,
      mb: props.mb || propsData.value.styles?.mb,
      pd: props.pd || propsData.value.styles?.pd,
      pdt: props.pdt || propsData.value.styles?.pdt,
      pdl: props.pdl || propsData.value.styles?.pdl,
      pdr: props.pdr || propsData.value.styles?.pdr,
      pdb: props.pdb || propsData.value.styles?.pdb,
      ta: props.ta || propsData.value.styles?.ta,
      lh: props.lh || propsData.value.styles?.lh,
      bd: props.bd || propsData.value.styles?.bd,
      bdr: props.bdr || propsData.value.styles?.bdr,
      bsw: props.bsw || propsData.value.styles?.bsw,
      p: props.p || propsData.value.styles?.p || 'absolute',
      pz: props.pz || propsData.value.styles?.pz,
      ps: props.ps || propsData.value.styles?.ps,
      pt: props.pt || propsData.value.styles?.pt,
      pb: props.pb || propsData.value.styles?.pb,
      pl: props.pl || propsData.value.styles?.pl,
      pr: props.pr || propsData.value.styles?.pr,
      pc: props.pc || propsData.value.styles?.pc,
    }
  })

  return {
    mergedStyles,
    propsData,
  }
}
